import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import LoadingSpinner from '../components/common/LoadingSpinner/LoadingSpinner';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/login" replace />;
  }

  // Prevent access to other pages if user needs to complete onboarding
  if (['mentor', 'student', 'counsellor'].includes(user?.role) && !user?.details_added) {
    if (!window.location.pathname.includes(`/${user.role}/onboarding`)) {
      return <Navigate to={`/${user.role}/onboarding`} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;